module.exports = __webpack_public_path__ + "img/digitalIdentity4.38892f60.png";